module.exports = __webpack_public_path__ + "media/images/weather/sunny-2119b800ba047e381680f52442df81c9.jpg";